/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'


/*
 * 获取权限
 */
export function menuAll(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/menuAll', params, options)
}

/*
 * 获取权限
 */
export function uniqueKey(params, options) {
  return httpAgent.GET('/scsadmin/admin/private/Yinfo/uniqueKey', params, options)
}

/*
* 获取按钮权限
*/
export function buttonAll(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/buttonAll', params, options)
}
